import axios from "axios";
import { getToken, logout } from "../services/auth";

export const headers = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

// Sempre injeta o token atual (corrige o header default stale e cobre a troca
// para o token de impersonation sem reload).
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token && typeof token === "string") {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 401 = token invalido/expirado/sessao de impersonation revogada -> desloga.
// (NAO tratamos 403, que e usado para autorizacao de negocio.)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error && error.response ? error.response.status : null;
    if (status === 401) {
      logout();
      if (window.location.hash !== "#/entrar") {
        window.location.hash = "#/entrar";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
